import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../../../_actions/dataActions";
import Wrapper from "../../../../../../_hoc/Wrapper";
import PageSubTitle from "../../../../../UI/PageSubTitle";
import EditWidget from "../../../../../UI/EditWidget";
import Select from "../../../../../UI/Select";
import CreatableSelect from "../../../../../UI/CreatableSelect";
import Textarea from "../../../../../UI/Textarea";
import DatePicker from "react-date-picker";

import GooglePlacesAutocomplete from "../../../../../UI/GooglePlacesAutocomplete";
import "./index.css";
import getMotherTongue from "../../../../../../_selectors/dataSelectors/getMotherTongue";
import getReligion from "../../../../../../_selectors/dataSelectors/getReligion";
import getCommunity from "../../../../../../_selectors/dataSelectors/getCommunity";
import getMaritalStatus from "../../../../../../_selectors/dataSelectors/getMaritalStatus";
import getCaste from "../../../../../../_selectors/dataSelectors/getCaste";

import { kebabCase } from "lodash";
class BasicDetail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userProfile) {
      const {
        birthDate,
        birthPlace,
        maritalStatus,
        children,
        motherTongue,
        religion,
        community,
        caste,
        address,
        information
      } = nextProps.userProfile;
      const {
        selectedBirthDate,
        selectedBirthPlace,
        selectedMaritalStatus,
        selectedChildren,
        selectedMotherTongue,
        selectedReligion,
        selectedCommunity,
        selectedCaste,
        selectedAddress,
        isEditModeOn,
        selectedInformation
      } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        return {
          selectedBirthDate: birthDate,
          selectedBirthPlace: birthPlace,
          selectedMaritalStatus: maritalStatus,
          selectedChildren: children,
          selectedMotherTongue: motherTongue,
          selectedReligion: religion,
          selectedCommunity: community,
          selectedCaste: caste,
          selectedAddress: address,
          selectedInformation: information
        };
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    showEdit: this.props.showEdit,
    selectedBirthDate: null,
    selectedBirthPlace: "",
    selectedMaritalStatus: null,
    selectedChildren: null,
    selectedMotherTongue: null,
    selectedReligion: null,
    selectedCommunity: null,
    selectedCaste: null,
    selectedAddress: "",
    selectedInformation: ""
  };
  componentDidMount() {
    const {
      motherTongue,
      getMotherTongueData,
      religion,
      getReligionData,
      maritalStatus,
      getMaritalStatusData,
      caste,
      getCasteData,
      userProfile,
      getCommunityData
    } = this.props;
    if (motherTongue.length === 0) {
      getMotherTongueData();
    }
    if (religion.length === 0) {
      getReligionData();
    }
    if (maritalStatus.length === 0) {
      getMaritalStatusData();
    }
    if (caste.length === 0) {
      getCasteData();
    }

    if (userProfile) {
      if (userProfile.religion) {
        getCommunityData(userProfile.religion.value);
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userProfile) {
      if (prevProps.userProfile.religion) {
        if (
          prevProps.userProfile.religion !== this.props.userProfile.religion
        ) {
          if (this.props.userProfile.religion) {
            this.props.getCommunityData(this.props.userProfile.religion.value);
          }
        }
      }
    }
  }
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const {
      selectedAddress,
      selectedBirthDate,
      selectedBirthPlace,
      selectedCaste,
      selectedChildren,
      selectedCommunity,
      selectedInformation,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion
    } = this.state;
    const { update, toast } = this.props;
    const updatedBasicDetail = {
      birthDate: selectedBirthDate,
      birthPlace: selectedBirthPlace,
      maritalStatus: selectedMaritalStatus,
      children: selectedChildren,
      motherTongue: selectedMotherTongue,
      religion: selectedReligion,
      community: selectedCommunity,
      caste: selectedCaste,
      address: selectedAddress,
      information: selectedInformation
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
      toast({ type: "info", message: "Profile Updated" });
    };
    const onError = err => {
      console.log(err);
      toast({ type: "error", message: err });
    };
    update({ data: updatedBasicDetail, onSuccess, onError });
  };
  render() {
    const {
      textarea,
      selectedBirthDate,
      selectedCaste,
      selectedChildren,
      selectedCommunity,
      selectedInformation,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      isEditModeOn,
      showEdit,
      selectedAddress,
      selectedBirthPlace
    } = this.state;
    const {
      motherTongue,
      religion,
      community,
      getCommunityData,
      caste,
      maritalStatus,
      userProfile,
      hideTitle,
      createCommunity
    } = this.props;
    return (
      <Wrapper>
        {hideTitle ? null : (
          <PageSubTitle>
            <h3>
              Basic Detail
              <EditWidget
                edit={isEditModeOn}
                onEdit={this.enableEditMode}
                onSave={this.save}
                onCancel={this.disableEditMode}
                disabled={userProfile.cache}
                show={showEdit}
              />
            </h3>
            <p />
          </PageSubTitle>
        )}

        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group form-group-custom">
                <label>Date of Birth</label>
                <div className="form-control-clear-wrap">
                  <DatePicker
                    onChange={date => {
                      this.setState({ selectedBirthDate: date });
                    }}
                    value={selectedBirthDate}
                    clearIcon={null}
                    disabled={!isEditModeOn}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <GooglePlacesAutocomplete
                label={<label>Birth Place</label>}
                readOnly={!isEditModeOn}
                value={selectedBirthPlace}
                onSelect={address => {
                  this.setState({ selectedBirthPlace: address });
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Marital Status</Wrapper>}
                selected={selectedMaritalStatus}
                options={maritalStatus}
                onChange={value => {
                  this.setState({ selectedMaritalStatus: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Children</Wrapper>}
                selected={selectedChildren}
                options={[
                  { label: "None", value: 0 },
                  { label: "1", value: 1 },
                  { label: "2", value: 2 },
                  { label: "3", value: 3 },
                  { label: "4", value: 4 },
                  { label: "5", value: 5 },
                  { label: "6", value: 6 },
                  { label: "7", value: 7 },
                  { label: "8", value: 8 },
                  { label: "9", value: 9 }
                ]}
                onChange={value => {
                  this.setState({ selectedChildren: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Mother Tongue</Wrapper>}
                selected={selectedMotherTongue}
                options={motherTongue}
                onChange={value => {
                  this.setState({ selectedMotherTongue: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Religion</Wrapper>}
                selected={selectedReligion}
                options={religion}
                onChange={value => {
                  this.setState({ selectedReligion: value }, () => {
                    getCommunityData(value.value);
                  });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <CreatableSelect
                label={<Wrapper>Community</Wrapper>}
                selected={selectedCommunity}
                options={community}
                onChange={value => {
                  if (value) {
                    if (value.className) {
                      //create community

                      this.setState(
                        {
                          selectedCommunity: {
                            label: value.label,
                            value: kebabCase(value.label)
                          }
                        },
                        () => {
                          createCommunity({
                            religion: selectedReligion,
                            community: value
                          });
                        }
                      );
                    } else {
                      this.setState({ selectedCommunity: value });
                    }
                  } else {
                    this.setState({ selectedCommunity: value });
                  }
                }}
                promptTextCreator={text => `Create Community "${text}"`}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={
                  !isEditModeOn
                    ? true
                    : selectedReligion === null
                      ? true
                      : false
                }
              />
            </div>
            {/* <div className="col-md-4">
              <Select
                label={<Wrapper>Caste</Wrapper>}
                selected={selectedCaste}
                options={caste}
                onChange={value => {
                  this.setState({ selectedCaste: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div> */}
          </div>
          <div className="row">
            <div className="col-md-12">
              <GooglePlacesAutocomplete
                label={<label>Address</label>}
                readOnly={!isEditModeOn}
                value={selectedAddress}
                onSelect={address => {
                  this.setState({ selectedAddress: address });
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Textarea
                value={selectedInformation}
                onChange={value => {
                  this.setState({ selectedInformation: value });
                }}
                label={<Wrapper>Tell Us about yourself</Wrapper>}
                onClear={() => {
                  this.setState({ selectedInformation: "" });
                }}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  motherTongue: getMotherTongue(state),
  religion: getReligion(state),
  community: getCommunity(state),
  maritalStatus: getMaritalStatus(state),
  caste: getCaste(state)
});
const mapDispatchToProps = dispatch => ({
  getMotherTongueData: () => dispatch(dataActions.getMotherTongue()),
  getReligionData: () => dispatch(dataActions.getReligion()),
  getCommunityData: religion =>
    dispatch(dataActions.getCommunityByReligion(religion)),
  createCommunity: payload =>
    dispatch(dataActions.createCommunityByReligion(payload)),
  getMaritalStatusData: () => dispatch(dataActions.getMaritalStatus()),
  getCasteData: () => dispatch(dataActions.getCaste())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasicDetail);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Basic/BasicDetail/index.js